import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '../../../app/hooks';
import { getValueFromResource } from '../../../common/timeLiveFunction';

const GeofencingMapApiForm = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const validationSchema = Yup.object({
        mapApiKey: Yup.string().required('Map API Key is required').min(10, 'Please enter a valid API Key'),
    });

    const initialValues = {
        mapApiKey: '',
    };

    const handleSubmit = async (values: typeof initialValues, { setSubmitting }: any) => {
        try {
            const payload = {
                mapApiKey: values.mapApiKey,
            };

            console.log('Saving API Key:', payload);

        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="card card-custom admin-card">
            <div className="card-header card-drop sticky-top bg-white fixed-top">
                <h3 className="card-title fw-bold mainHeading">
                    {getValueFromResource('Map API Key', dispatch, t)}
                </h3>
            </div>

            <div className="card-body">
                <div className="alert alert-warning mb-5">
                    {getValueFromResource(' Please enter a valid Map API key. This key will be securely stored and used across the application for map-related features including geofencing, location tracking, and map visualization. Any changes to this key may affect map functionality throughout the system.', dispatch, t)}
                </div>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 mb-5">
                                    <input
                                        type="text"
                                        name="mapApiKey"
                                        className="form-control"
                                        placeholder="Enter Map API Key"
                                        value={values.mapApiKey}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />

                                    {touched.mapApiKey && errors.mapApiKey && (
                                        <div className="text-danger mt-1">
                                            {errors.mapApiKey}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Save
                            </button>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default GeofencingMapApiForm;